import { useEffect, useState, useRef } from "react";
import websocketClient from "../utils/websocketClient";
import axios from "axios";

const useChat = (userId) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const CLIENT_URL =process.env.REACT_APP_CLIENT_BASE_URL

  const WS_URL = process.env.REACT_APP_WS_BASE_URL;

  const token = localStorage.getItem("access_token");
  const [messages, setMessages] = useState([]);
  const hasLoadedHistory = useRef(false);

  const fetchMessages = async () => {
    if (!userId || !token) return;

    try {
      const res = await axios.get(
        `${BASE_URL}/user/chat/messages-by-profileID/`,
        {
          params: { friend_id: userId },
          headers: {
            Authorization: `Bearer ${token}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        }
      );
      // console.log("The responsie is:",res.data)
      const formatted = (res.data || [])
        .map((msg) => ({
          id: msg.id,
          message: msg.message,
          file:msg.file,
          sent_by_me: msg.message_by === "me",
          timestamp: msg.created_at,
        }))
        .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

      setMessages(formatted);
    } catch (err) {
      console.error("Failed to fetch chat history:", err);
    }
  };

  useEffect(() => {
    if (!userId || !token) return;
    setMessages([]);
    fetchMessages();
    const socketName = `chat-${userId}`;
    const url = `${WS_URL}/ws/chat/${userId}/`;

    websocketClient.connect(socketName, url, token);

   const handleMessage = (data) => {
  if (data.messages && !hasLoadedHistory.current) {
    setMessages(data.messages);
    hasLoadedHistory.current = true;
  } else if (data.message || data.file) {  // ← Add "data.file" check
    if (data.message && data.message.startsWith("Connected as")) {
      return;
    }
    
    // Handle both text and file messages
    const formatted = {
      id: data.id || data.temp_id || Date.now(),
      message: data.message,
      file: data.file_data || data.file,  // ← Add file handling
      file_name: data.file_name,          // ← Add file_name
      sent_by_me: data.sender_id !== userId, 
      timestamp: data.timestamp || new Date().toISOString(),
    };

    setMessages((prev) => [...prev, formatted]);  // ← Use formatted object
  }
};

    websocketClient.subscribe(socketName, handleMessage);

    return () => {
      websocketClient.unsubscribe(socketName, handleMessage);
      websocketClient.disconnect(socketName);
      hasLoadedHistory.current = false;
    };
  }, [userId]);

  const sendMessage = async (content) => {
    if (!content.trim()) return;
    const socketName = `chat-${userId}`;

    const localMessage = {
      message: content,
      sent_by_me: true,
      timestamp: new Date().toISOString(),
    };
    setMessages((prev) => [...prev, localMessage]);
    // websocketClient.send(socketName, { message: content });
    websocketClient.send(socketName, {
  type: "text",
  message: content,
});

    await fetchMessages();
  };
 const sendFile = async (fileData) => {
    const socketName = `chat-${userId}`;
    const tempId = `temp_file_${Date.now()}`;
    
    // Create a local "uploading" message
    const localFileMessage = {
      file: fileData.file_data, // Base64 preview
      file_name: fileData.file_name,
      sent_by_me: true,
      timestamp: new Date().toISOString(),
      status: 'uploading',
    };
    
    setMessages(prev => [...prev, localFileMessage]);
    
    // Send via WebSocket
    websocketClient.send(socketName, {
      ...fileData,
      type: "file",
      temp_id: tempId,
    });

  //  await fetchMessages();
   setTimeout(() => {
    fetchMessages()
   }, 5000);
  };
  return { messages, sendMessage, setMessages ,fetchMessages,sendFile};
};

export default useChat;
